import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import img from '../../assets/cc-mini-back.png.js';
import img$1 from '../../assets/cc-mini-back@2x.png.js';
import img$2 from '../../assets/cc-mini-front.png.js';
import img$3 from '../../assets/cc-mini-front@2x.png.js';
import styles from './CVVIcon.module.scss.js';

const IMAGES = {
    cvvBack: {
        lowRs: img,
        highRs: img$1,
        dataZta: '',
    },
    cvvFront: {
        lowRs: img$2,
        highRs: img$3,
        dataZta: '',
    },
};
const CVVIcon = ({ isAmex, className }) => {
    const type = isAmex ? 'cvvFront' : 'cvvBack';
    const image = IMAGES[type];
    return image ? (jsx("img", { className: classNames(styles.cvvIcon, className), src: image.lowRs, alt: type, srcSet: `${image.lowRs} 1x, ${image.highRs} 2x`, "data-zta": image.dataZta })) : null;
};

export { CVVIcon as default };
//# sourceMappingURL=CVVIcon.js.map
